// Where "go to login" should land under the unified portal: the user's own dex
// login page when known (portal.../sgbuildex), else the selection page (/login).
// The portal validates the slug — a stale/unknown value degrades to the
// selection screen there, so no validation is needed here.
export function portalLoginPath(suffix = '') {
	const dex =
		typeof window !== 'undefined' && window.sessionStorage
			? window.sessionStorage.getItem('selectedDex')
			: null;
	const base = dex ? `/${dex}` : '/login';
	return `${base}${suffix}`;
}
